import React from "react";
import { IAppState } from "../interfaces/App";
import { useSelector } from "react-redux";

function Fogg() {
    const app: IAppState = useSelector((appState: any) => appState.app);
    return app.fogg 
        ? (
            <div className="fogg"/>
        ) : (
            null
        );
}
export default Fogg;
